webpackJsonp([107],{

/***/ 1247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






var metas = {
  "category": {
    "en": "DataDisplay",
    "zh-CN": "数据展示"
  },
  "icon": "&#xe656;",
  "import_code": "import { Timeline, TimelineItem } from 'vux'",
  "extra": "待补充\n",
  "changes": {
    "v2.1.1-rc.10": {
      "en": ["[fix] Fix icon position"],
      "zh-CN": ["[fix] 修复图标位置"]
    }
  },
  "variables": [{
    "name": "timeline-item-bg-color",
    "value": "#04BE02",
    "is_inherited": true,
    "inherited_name": "@theme-color",
    "desc": {}
  }]
};
var demos = [];

var componentList = [];
if (Array.isArray(metas.items)) {
  try {
    metas.items.forEach(function (item, index) {
      var meta = {
        name: item,
        meta: metas[item]
      };
      if (meta.meta.props === null) {
        delete meta.meta.props;
      }
      if (index === metas.items.length - 1) {
        if (meta.meta) {
          meta.meta.variables = metas.variables;
        }
      }
      componentList.push(meta);
    });
  } catch (e) {
    console.log(e);
  }
} else {
  componentList.push({
    meta: metas
  });
}
var gitMetas = __webpack_require__(847);
var demoCode = decodeURIComponent("%3Cpre%20class%3D%22hljs%22%3E%3Ccode%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eclass%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22timeline-demo%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Etimeline%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Etimeline-item%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Eh4%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eclass%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22recent%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%E3%80%90%E5%B9%BF%E4%B8%9C%E3%80%91%20%E5%B9%BF%E5%B7%9E%E5%B8%82%20%E5%B7%B2%E5%8F%91%E5%87%BA%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Eh4%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ep%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eclass%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22recent%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E2016-04-17%2012%3A00%3A00%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ep%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Etimeline-item%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Etimeline-item%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Eh4%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%20%E7%94%B3%E9%80%9A%E5%BF%AB%E9%80%92%E5%91%98%20%E5%B9%BF%E4%B8%9C%E5%B9%BF%E5%B7%9E%20%E6%94%B6%E4%BB%B6%E5%91%98%20xxx%20%E5%B7%B2%E6%8F%BD%E4%BB%B6%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Eh4%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ep%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E2016-04-16%2010%3A23%3A00%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ep%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Etimeline-item%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Etimeline-item%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Eh4%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%20%E5%95%86%E5%AE%B6%E6%AD%A3%E5%9C%A8%E9%80%9A%E7%9F%A5%E5%BF%AB%E9%80%92%E5%85%AC%E5%8F%B8%E6%8F%BD%E4%BB%B6%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Eh4%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ep%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E2016-04-15%209%3A00%3A00%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ep%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Etimeline-item%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Etimeline%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Etimeline%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Etimeline-item%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-for%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22(i%2C%20index)%20in%20count%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Akey%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22index%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Eh4%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aclass%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%5Bi%20%3D%3D%3D%200%20%3F%20'recent'%20%3A%20''%5D%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3ETimeline%20Node%20%7B%7Bi%20%2B%201%7D%7D%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Eh4%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ep%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aclass%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%5Bi%20%3D%3D%3D%200%20%3F%20'recent'%20%3A%20''%5D%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3Eindex%20%7B%7Bi%20%2B%201%7D%7D%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ep%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Etimeline-item%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Etimeline%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etype%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22primary%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22count%20%3D%206%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%20Set%20to%206%20nodes%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etype%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22primary%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22count%20%3D%203%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%20Set%20to%203%20nodes%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ex-button%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%09%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%0D%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Escript%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22javascript%22%3E%0D%0A%3Cspan%20class%3D%22hljs-keyword%22%3Eimport%3C%2Fspan%3E%20%7B%20Timeline%2C%20TimelineItem%2C%20XButton%20%7D%20%3Cspan%20class%3D%22hljs-keyword%22%3Efrom%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-string%22%3E'vux'%3C%2Fspan%3E%0D%0A%0D%0A%3Cspan%20class%3D%22hljs-keyword%22%3Eexport%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-keyword%22%3Edefault%3C%2Fspan%3E%20%7B%0D%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3Ecomponents%3C%2Fspan%3E%3A%20%7B%0D%0A%20%20%20%20Timeline%2C%0D%0A%20%20%20%20TimelineItem%2C%0D%0A%20%20%20%20XButton%0D%0A%20%20%7D%2C%0D%0A%20%20data%20()%20%7B%0D%0A%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ereturn%3C%2Fspan%3E%20%7B%0D%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Ecount%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-number%22%3E3%3C%2Fspan%3E%0D%0A%20%20%20%20%7D%0D%0A%20%20%7D%0D%0A%7D%0D%0A%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Escript%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%0D%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Estyle%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Elang%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22less%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22undefined%22%3E%0D%0A.timeline-demo%20%7B%0D%0A%09p%20%7B%0D%0A%09%09color%3A%20%23888%3B%0D%0A%09%09font-size%3A%200.8rem%3B%0D%0A%09%7D%0D%0A%09h4%20%7B%0D%0A%09%09color%3A%20%23666%3B%0D%0A%09%09font-weight%3A%20normal%3B%0D%0A%09%7D%0D%0A%09.recent%20%7B%0D%0A%09%09color%3A%20rgb(4%2C%20190%2C%202)%0D%0A%09%7D%0D%0A%7D%0D%0A%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Estyle%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0D%0A%3C%2Fcode%3E%3C%2Fpre%3E");

var domainMap = {
  'development': 'http://localhost:8080/',
  'production': 'https://vux-demos.bobjoy.eu.org/'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  head: {
    title: 'Timeline component tutorial | VUX - Vue.js Mobile UI Component Framework',
    meta: [{
      name: 'description',
      content: 'Vue component timeline for the VUX framework.'
    }, {
      name: 'keywords',
      content: 'timeline, vue-timeline, vux-timeline, vue mobile components'
    }, {
      property: 'og:title',
      content: 'Timeline component tutorial | VUX - Vue.js Mobile UI Component Framework'
    }, {
      property: 'og:description',
      content: 'Vue component timeline for the VUX framework.'
    }],

    link: [{ "rel": "alternate", "hreflang": "zh-CN", "href": "/zh-CN/components/timeline.html" }],
    script: [{
      innerHTML: '{"@context":"http://schema.org/","@type":"SoftwareApplication","name":"Vue Component timeline","screenshot":"","description":"Vue.js component for VUX","url":"/en/components/timeline.html","applicationCategory":"Component","author":{"@type":"Organization","name":"VUX","url":"https://vux.li"},"downloadUrl":"https://vux.li","softwareVersion":"2.11.1","aggregateRating":{"@type":"AggregateRating","ratingValue":5,"reviewCount":1},"operatingSystem":"iOS >= 7, Android >= 4.1","offers":{"@type":"Offer","price":0,"priceCurrency":"USD","availability":"http://schema.org/InStock"}}',
      type: 'application/ld+json'
    }],
    __dangerouslyDisableSanitizers: ['script']
  },
  filters: {
    parseCode: function parseCode(str) {
      return str.replace(/`(.*?)`/g, '<code>$1</code>');
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var rs;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://api.github.com/search/issues?q=repo:airyland/vux%20label:component/' + _this.componentName);

            case 2:
              rs = _context.sent;

              _this.issues = rs.data.items;
              _this.hasReady = true;

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    sourceCodeDialogVisibility: function sourceCodeDialogVisibility(val) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var mask;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!val) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return _this2.$nextTick();

              case 3:
                mask = document.querySelector('.v-modal');

                mask && mask.addEventListener('click', function () {
                  _this2.sourceCodeDialogVisibility = false;
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  methods: {
    onCopyError: function onCopyError() {
      this.$message({
        type: 'error',
        message: 'copy fail!'
      });
    },
    onCopy: function onCopy() {
      this.$message({
        type: 'success',
        message: 'copy done!'
      });
    },
    showSourceCode: function showSourceCode() {
      this.sourceCodeDialogVisibility = true;
    },
    getTypeHTML: function getTypeHTML(type) {
      type = type || 'String';
      if (/,/.test(type)) {
        var list = type.split(',').map(function (one) {
          return one.replace(/^s+|s+$/g, '');
        }).map(function (one) {
          var type = one ? one.toLowerCase() : 'string';
          return '<span class="type">' + type + '</span>';
        });
        return list.join('<br>');
      } else {
        type = type ? type.toLowerCase() : 'string';
        return '<span class="type">' + type + '</span>';
      }
    }
  },
  computed: {
    lang: function lang() {
      if (this.$route.path.indexOf('/en/') !== -1) {
        return 'en';
      }
      if (this.$route.path.indexOf('/zh-CN/') !== -1) {
        return 'zh-CN';
      }
      return 'en';
    }
  },
  data: function data() {
    return {
      demos: demos,
      isBeta: false,
      hasReady: false,
      issues: [],
      componentName: 'timeline',
      demoCode: demoCode,
      sourceCodeDialogVisibility: false,
      showQr: false,
      metas: metas,
      gitMetas: gitMetas,
      componentList: componentList,
      localImportCode: "import { Timeline } from 'vux'\n\nexport default {\n  components: {\n    Timeline\n  }\n}",
      globalImportCode: "// you can also register globally\n\nimport Vue from 'vue'\nimport { Timeline } from 'vux'\n\nVue.component('timeline', Timeline)\n",
      needImport: true,
      toc: [],
      domain: domainMap["production"]
    };
  }
});

/***/ }),

/***/ 1476:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(306)(false);
// imports


// module
exports.push([module.i, ".component-box{position:relative}.component-demo{position:absolute;right:5px;top:15px}.prop-color{display:inline-block;width:10px;height:10px;border:1px solid #aaa}.changelog-version{width:110px;display:inline-block}.component-extra-links{position:relative;font-size:12px}.component-extra-links a{padding-right:10px;color:#999}", ""]);

// exports


/***/ }),

/***/ 1642:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1476);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(307)("858b0356", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"autoprefixer\":false,\"sourceMap\":false,\"minimize\":true}!../../node_modules/ream/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8891522c\",\"scoped\":false,\"hasInlineConfig\":true}!../../node_modules/ream/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./timeline.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"autoprefixer\":false,\"sourceMap\":false,\"minimize\":true}!../../node_modules/ream/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8891522c\",\"scoped\":false,\"hasInlineConfig\":true}!../../node_modules/ream/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./timeline.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2380:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-box",
    class: _vm.demos.length ? 'components-with-toc' : ''
  }, [_c('div', {
    class: _vm.demos.length ? 'component-header-v2' : 'component-header-v1'
  }, [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "intro"
    }
  }, [_vm._v("Timeline")]), _c('div', {
    staticClass: "title-box"
  }, [(_vm.isBeta) ? _c('el-badge', {
    attrs: {
      "value": "Beta"
    }
  }, [_c('h1', {
    staticClass: "vux-component-name"
  }, [_vm._v("Timeline")])]) : _c('h1', {
    staticClass: "vux-component-name"
  }, [_vm._v("Timeline")]), _c('p', {
    staticClass: "component-extra-links"
  }, [_c('a', {
    attrs: {
      "href": "https://vux-demos.bobjoy.eu.org/#/component/timeline",
      "target": "_blank"
    }
  }, [_vm._v("demo url")]), (!_vm.demos.length) ? _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Timeline.vue",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSourceCode($event)
      }
    }
  }, [_vm._v("demo source code")]) : _vm._e(), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/timeline/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("edit document")]), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/timeline/",
      "target": "_blank"
    }
  }, [_vm._v("component source code")]), (_vm.hasReady) ? _c('el-popover', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "qr",
    attrs: {
      "width": "100",
      "src": "https://qr.vux.li/api.php?text=https%3A%2F%2Fvux-demos.bobjoy.eu.org%2F%23%2Fcomponent%2Ftimeline"
    }
  })]), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    slot: "reference"
  }, [_vm._v("\n              view demos on mobile\n              ")])]) : _vm._e()], 1), _c('div', {
    staticClass: "component-description"
  }, [(false) ? void 0 : _vm._e()], 2)], 1), (!_vm.demos.length) ? _c('div', {
    staticClass: "component-demo",
    staticStyle: {
      "width": "377px",
      "height": "600px",
      "display": "inline-block",
      "border": "1px solid #ececec",
      "border-radius": "5px",
      "overflow": "hidden",
      "z-index": "2500"
    }
  }, [_c('iframe', {
    attrs: {
      "src": "https://vux-demos.bobjoy.eu.org?locale=en&transition=none/#/component/timeline",
      "width": "375",
      "height": "600",
      "border": "0",
      "frameborder": "0"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "toc"
  }, _vm._l((_vm.toc), function(t) {
    return _c('ul', [_c('li', [_c('a', {
      attrs: {
        "href": '#' + (t.anchor || t.title)
      }
    }, [_vm._v(_vm._s(t.title))]), _vm._l((t.list), function(_t) {
      return (t.list) ? _c('ul', [_c('li', [_c('a', {
        attrs: {
          "href": '#' + _t.anchor
        }
      }, [_vm._v(_vm._s(_t.title.slice(0, 12)))])])]) : _vm._e()
    })], 2)])
  })), (_vm.needImport) ? [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "install"
    }
  }, [_vm._v("Install")]), _c('h2', [_vm._v("Install")]), _c('el-tabs', [_c('el-tab-pane', {
    attrs: {
      "label": "Local Registration"
    }
  }, [_c('div', {
    staticClass: "import-code-box"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "click to copy",
      "placement": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.localImportCode),
      expression: "localImportCode",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onCopyError),
      expression: "onCopyError",
      arg: "error"
    }]
  }, [_c('el-icon', {
    staticClass: "el-icon-document"
  })], 1)]), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Timeline } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("components")]), _vm._v(": {\n    Timeline\n  }\n}")])])], 1)]), _c('el-tab-pane', {
    attrs: {
      "label": "Global Registration"
    }
  }, [_c('div', {
    staticClass: "import-code-box"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "click to copy",
      "placement": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.globalImportCode),
      expression: "globalImportCode",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onCopyError),
      expression: "onCopyError",
      arg: "error"
    }]
  }, [_c('el-icon', {
    staticClass: "el-icon-document"
  })], 1)]), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// you can also register globally")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" Vue "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vue'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Timeline } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\nVue.component("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'timeline'")]), _vm._v(", Timeline)\n")])])], 1)])], 1)] : [_c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("You don't need to import this component.")])])], (_vm.metas.tip) ? _c('div', {
    staticClass: "tip",
    staticStyle: {
      "width": "600px"
    }
  }) : _vm._e(), (_vm.metas.example) ? _c('h2', [_vm._v("example")]) : _vm._e(), (_vm.metas.example) ? _c('div', {
    staticStyle: {
      "width": "600px"
    }
  }) : _vm._e()], 2), (_vm.metas.extra && _vm.metas.extra['en']) ? _c('div') : _vm._e(), (_vm.metas.extra && !_vm.metas.extra['en']) ? _c('div', [_c('p', [_vm._v("待补充")])]) : _vm._e(), (_vm.demos.length) ? _c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "examples"
    }
  }, [_vm._v("Examples")]) : _vm._e(), _c('br'), _vm._l((_vm.demos), function(demo) {
    return (_vm.demos.length) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": 'examples:' + demo.title
      }
    }, [_vm._v(_vm._s(demo.title))]), _c('br'), _c('div', {
      staticClass: "demo-header"
    }, [_c('span', {
      staticClass: "demo-title"
    }, [_vm._v(_vm._s(demo.title))])]), _c('div', {
      staticClass: "demos",
      style: ({
        height: demo.height
      })
    }, [_c('div', {
      staticClass: "demo-iframe-box"
    }, [_c('lazy-component', [_c('iframe', {
      staticStyle: {
        "margin": "0 auto"
      },
      attrs: {
        "src": _vm.domain + '?no-background-color=' + demo.noBackgroundColor + '&locale=en&transition=none&hide-nav=true&hide-tab-bar=true#/components/' + demo.file,
        "width": "375",
        "height": "600",
        "border": "0",
        "frameborder": "0"
      }
    })], 1)], 1), _c('div', {
      staticClass: "demo-code-box",
      style: ({
        overflow: demo.height === demo.oriHeight ? 'hidden' : 'scroll'
      })
    }, [_c('div', {
      attrs: {
        "contenteditable": ""
      },
      domProps: {
        "innerHTML": _vm._s(demo.code)
      }
    }), (demo.height === demo.oriHeight) ? _c('div', {
      staticClass: "demo-code-masker",
      on: {
        "click": function($event) {
          demo.height = 'auto'
        }
      }
    }, [_c('div', [_c('img', {
      staticClass: "demo-qr",
      attrs: {
        "width": "100",
        "src": 'https://qr.vux.li/api.php?text=' + encodeURIComponent(_vm.domain + '?locale=en#/components/' + demo.file)
      }
    }), _c('br'), _c('span', [_c('el-icon', {
      staticClass: "el-icon-arrow-left"
    }), _c('el-icon', {
      staticClass: "el-icon-arrow-right"
    }), _vm._v("\n                    Show code\n                  "), _c('br')], 1)])]) : _vm._e(), (demo.height === 'auto') ? _c('span', {
      staticClass: "hide-code",
      on: {
        "click": function($event) {
          demo.height = demo.oriHeight
        }
      }
    }, [_c('el-icon', {
      staticClass: "el-icon-close"
    })], 1) : _vm._e()])])] : _vm._e()
  }), _vm._l((_vm.componentList), function(component) {
    return [_c('div', [(_vm.componentList.length > 1) ? _c('a', {
      staticClass: "anchor",
      attrs: {
        "id": 'components:' + component.name
      }
    }, [_vm._v(_vm._s(component.name))]) : _c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "api"
      }
    }, [_vm._v("API")]), _c('br'), _c('h2', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.componentList.length > 1),
        expression: "componentList.length > 1"
      }],
      staticClass: "vux-component-name-sub-item"
    }, [_vm._v(_vm._s(component.name))]), (component.meta.items && component.meta.description) ? [_c('div', {
      domProps: {
        "innerHTML": _vm._s(component.meta.description)
      }
    })] : _vm._e(), (component.meta.props) ? [_c('h2', [_vm._v("Props")]), _c('table', [_vm._m(0, true), _c('tbody', _vm._l((component.meta.props), function(prop, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "click to copy",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(_vm.getTypeHTML(prop.type))
        }
      }), _c('td', [_vm._v(_vm._s(prop.default))]), _c('td', {
        domProps: {
          "innerHTML": _vm._s(prop['en'] ? prop['en'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(prop.version || '--'))])])
    }))])] : _vm._e(), (component.meta.events) ? [_c('h2', [_vm._v("Events")]), _c('table', [_vm._m(1, true), _c('tbody', _vm._l((component.meta.events), function(event, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "click to copy",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: ('@' + i),
          expression: "'@' + i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v("@" + _vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(event.params ? event.params.replace(/`(.*?)`/g, '<code>$1</code>') : '--')
        }
      }), _c('td', {
        domProps: {
          "innerHTML": _vm._s(event['en'] ? event['en'].replace(/`(.*?)`/g, '<code>$1</code>') : '--')
        }
      }), _c('td', [_vm._v(_vm._s(event['version'] || '--'))])])
    }))])] : _vm._e(), (component.meta.slots) ? [_c('h2', [_vm._v("Slots")]), _c('table', [_vm._m(2, true), _c('tbody', _vm._l((component.meta.slots), function(slot, i) {
      return _c('tr', {
        class: {
          'slot-disabled': slot['status'] === 'deprecated'
        }
      }, [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "click to copy",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i === 'default' ? 'default' : i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(slot['en'] ? slot['en'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(slot['version'] || '--'))])])
    }))])] : _vm._e(), (component.meta.methods) ? [_c('h2', [_vm._v("Functions")]), _c('table', [_vm._m(3, true), _c('tbody', _vm._l((component.meta.methods), function(method, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "click to copy",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(method['params'] ? method['params'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', {
        domProps: {
          "innerHTML": _vm._s(method['en'] ? method['en'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(method['version']))])])
    }))])] : _vm._e(), (component.meta.variables) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "variables"
      }
    }, [_vm._v("Variables")]), _c('br'), _c('h2', [_vm._v("Variables")]), _c('table', [_vm._m(4, true), _c('tbody', _vm._l((component.meta.variables), function(variable, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "click to copy",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: ('@' + variable.name),
          expression: "'@' + variable.name",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v("@" + _vm._s(variable.name))])])], 1), _c('td', [(!_vm.$refs['propColor' + i] || (_vm.$refs['propColor' + i][0] && _vm.$refs['propColor' + i][0].style.backgroundColor)) ? _c('em', {
        ref: 'propColor' + i,
        refInFor: true,
        staticClass: "prop-color",
        style: ({
          backgroundColor: variable.value
        })
      }) : _vm._e(), _vm._v("\n                    " + _vm._s(variable.value) + "\n                  ")]), _c('td', [_vm._v(_vm._s(variable['desc']['en'] || '--'))]), _c('td', [_vm._v(_vm._s(variable.inherited_name))])])
    }))])] : _vm._e(), (component.meta.tips && component.meta.tips['en']) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "tips"
      }
    }, [_vm._v("Tips")]), _c('br'), _c('h2', [_vm._v("Tips")]), _c('div', [_c('ul', _vm._l((component.meta.tips['en']), function(tip) {
      return _c('li', [_c('el-tag', {
        staticClass: "component-tip-tag",
        attrs: {
          "size": "mini",
          "type": "success"
        }
      }, [_vm._v("Q")]), _c('span', {
        staticClass: "component-tip-question"
      }, [_vm._v(_vm._s(tip.q))]), _c('div', {
        staticClass: "tip-answer-box",
        domProps: {
          "innerHTML": _vm._s(tip.a)
        }
      })], 1)
    }))])] : _vm._e()], 2)]
  }), _c('br'), (_vm.issues.length) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "Issues"
    }
  }, [_vm._v("Issues")]), _c('br'), _c('h2', [_vm._v("Related issues")]), _c('ul', _vm._l((_vm.issues), function(issue) {
    return _c('li', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": issue.html_url
      }
    }, [_vm._v("#" + _vm._s(issue.number) + " "), _c('span', {
      staticStyle: {
        "color": "#666"
      }
    }, [_vm._v(_vm._s(issue.title))])])])
  }))]) : _vm._e(), _c('br'), (_vm.gitMetas) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "contributors"
    }
  }, [_vm._v("Contributors")]), _c('h2', [_vm._v("Contributors")]), _c('p', [_vm._v("Total commits quantity: " + _vm._s(_vm.gitMetas.commitCount) + "，Total contributors quantity: " + _vm._s(_vm.gitMetas.commitUniqueCount) + "\n        ")]), _vm._l((_vm.gitMetas.commitMembers), function(person) {
    return _c('a', {
      staticClass: "contributor-item",
      attrs: {
        "href": 'https://github.com/' + person.authorName,
        "target": "_blank",
        "title": 'contribute' + person.count
      }
    }, [_vm._v(_vm._s(person.authorName))])
  })], 2) : _vm._e(), _c('br'), (_vm.metas.changes) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "changelog"
    }
  }, [_vm._v("Changelog")]), _c('br'), _c('h2', [_vm._v("Releases")]), (_vm.metas.changes) ? _c('ul', [_vm._l((_vm.metas.changes), function(changelog, version) {
    return _vm._l((changelog['en']), function(log) {
      return _c('li', [_c('router-link', {
        staticClass: "changelog-version",
        attrs: {
          "to": '/en/changelog/' + version + '.html'
        }
      }, [_vm._v(_vm._s(version))]), _vm._v(" " + _vm._s(log) + "\n            ")], 1)
    })
  })], 2) : _vm._e()]) : _vm._e(), (_vm.metas.references) ? _c('h2', [_vm._v("Referrences")]) : _vm._e(), (_vm.metas.references) ? _c('ul', _vm._l((_vm.metas.references['en']), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.title))])])
  })) : _vm._e(), _c('el-dialog', {
    staticClass: "sourcec-code-dialog",
    attrs: {
      "top": "0",
      "width": "80%",
      "visible": _vm.sourceCodeDialogVisibility
    },
    on: {
      "update:visible": function($event) {
        _vm.sourceCodeDialogVisibility = $event
      }
    }
  }, [_c('div', {
    staticClass: "code-box",
    attrs: {
      "contenteditable": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.demoCode)
    }
  })])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("name")]), _c('td', {
    staticStyle: {
      "width": "48px"
    }
  }, [_vm._v("type")]), _c('td', [_vm._v("default")]), _c('td', [_vm._v("description")]), _c('td', [_vm._v("required version")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("name")]), _c('td', [_vm._v("params")]), _c('td', [_vm._v("description")]), _c('td', [_vm._v("required version")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("name")]), _c('td', [_vm._v("description")]), _c('td', [_vm._v("required version")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("name")]), _c('td', [_vm._v("params")]), _c('td', [_vm._v("description")]), _c('td', [_vm._v("required version")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("name")]), _c('td', [_vm._v("default")]), _c('td', [_vm._v("description")]), _c('td', [_vm._v("inherited name")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8891522c", module.exports)
  }
}

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1642)
}
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1247),
  /* template */
  __webpack_require__(2380),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/en/components/timeline.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] timeline.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8891522c", Component.options)
  } else {
    hotAPI.reload("data-v-8891522c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 847:
/***/ (function(module, exports) {

module.exports = {
	"commitCount": 1,
	"commitMembers": [
		{
			"count": 1,
			"authorName": "Bobjoy"
		}
	],
	"commitUniqueCount": 1
};

/***/ })

});


// WEBPACK FOOTER //
// 107.7f159597.js